import { defaultState } from "./state";
import payroll from "./action-types";
import commonTypes from "../common/action-types";
const types = { ...commonTypes, ...payroll };

const votingGroups = (
  votingGroupsState = defaultState.votingGroups,
  action
) => {
  switch (action.type) {
    case types.SET_VOTING_GROUPS:
      return action.data;

    case types.ADD_VOTING_GROUP: {
      const tmpState = [...votingGroupsState];
      tmpState.unshift(action.data);
      return tmpState;
    }

    // case types.UPDATE_CONTRACT: {
    //   const tmpState = [...votingGroupsState];
    //   const index = tmpState.findIndex(({ id }) => id === action.data.id);

    //   if (index < 0) return tmpState;

    //   if (tmpState[index].status === "Expired") {
    //     tmpState.splice(index, 1);
    //     return tmpState;
    //   }

    //   tmpState[index] = action.data;

    //   return tmpState;
    // }
    case types.DELETE_VOTING_GROUP:
      const tmpState = [...votingGroupsState];
      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      tmpState.splice(index, 1);

      return tmpState;

    case types.CLEAN_STATE:
      return defaultState.votingGroups;

    default:
      return votingGroupsState;
  }
};

const votingGroupUnits = (
  votingGroupUnitsState = defaultState.votingGroupUnits,
  action
) => {
  switch (action.type) {
    case types.SET_VOTING_GROUP_UNITS:
      return action.data;

    case types.CLEAN_STATE:
    case types.SET_VOTING_GROUPS:
      return defaultState.votingGroupUnits;

    default:
      return votingGroupUnitsState;
  }
};
const votingHighestScores = (
  votingHighestScoresState = defaultState.votingHighestScores,
  action
) => {
  switch (action.type) {
    case types.SET_VOTING_DEPART_HIGHEST_SCORES:
      return action.data;

    case types.ADD_OR_UPDATE_HIGHEST_SCORE: {
      const tmpState = [...votingHighestScoresState];
      const index = tmpState.findIndex(({ id }) => id === action.data.id);

      if (index >= 0) tmpState[index] = action.data;
      else tmpState.unshift(action.data);

      return tmpState;
    }

    case types.CLEAN_STATE:
    case types.SET_VOTING_GROUPS:
      return defaultState.votingHighestScores;

    default:
      return votingHighestScoresState;
  }
};
const votingDepartmentGroupScores = (
  votingDepartmentGroupScoresState = defaultState.votingDepartmentGroupScores,
  action
) => {
  switch (action.type) {
    case types.SET_VOTING_DEPART_GROUP_SCORES:
      return action.data;

    case types.CLEAN_STATE:
    case types.SET_VOTING_GROUPS:
      return defaultState.votingDepartmentGroupScores;

    default:
      return votingDepartmentGroupScoresState;
  }
};

// voting behavior reducer
const voteBehaviors = (voteBehaviorsState = defaultState.behaviors, action) => {
  switch (action.type) {
    case types.SET_VOTE_BEHAVIORS:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.behaviors;

    default:
      return voteBehaviorsState;
  }
};

// voting rating reducer
const voteRatings = (voteRatingsState = defaultState.ratings, action) => {
  switch (action.type) {
    case types.SET_VOTE_RATINGS:
      return action.data;

    case types.CLEAN_STATE:
      return defaultState.ratings;

    default:
      return voteRatingsState;
  }
};
const myVotes = (myVotesState = defaultState.myVotes, action) => {
  switch (action.type) {
    case types.SET_MY_VOTES:
      return action.data;

    case types.CLEAN_STATE:
    case types.SET_VOTING_GROUPS:
      return defaultState.myVotes;

    default:
      return myVotesState;
  }
};
export default {
  votingGroups,
  votingGroupUnits,
  votingHighestScores,
  votingDepartmentGroupScores,
  voteBehaviors,
  voteRatings,
  myVotes,
};
